import { siteConfig } from "@/config/site.config";
import routes from "@/routers/routes";
import SocialItems from "@/ui/social-shares";
import cn from "@/utils/class-names";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { Button } from "rizzui";

const ignoreBackButtonRoutes = [routes.accessDenied, routes.notFound];

// access denied, coming soon, not found, etc
export default function OtherPagesLayout({
    isSocialActive = true,
}: {
    isSocialActive?: boolean;
}) {
    const navigate = useNavigate();
    const location = useLocation();

    let notIn = !ignoreBackButtonRoutes.includes(location.pathname);
    return (
        <div className="flex min-h-screen flex-col bg-[#F8FAFC] dark:bg-gray-50">
            {/* sticky top header  */}
            <div className="sticky top-0 z-40 px-6 py-5 backdrop-blur-lg lg:backdrop-blur-none xl:px-10 xl:py-8">
                <div
                    className={cn(
                        "mx-auto flex max-w-[1520px] items-center",
                        notIn ? "justify-between" : "justify-center",
                    )}
                >
                    <Link to={"/"}>
                        <img
                            src={siteConfig.logo}
                            alt={siteConfig.title}
                            className="dark:invert"
                        />
                    </Link>
                    {notIn && (
                        <Button
                            variant="outline"
                            size="sm"
                            className="md:h-10 md:px-4 md:text-base"
                            onClick={() => navigate(-1)}
                        >
                            Go to home
                        </Button>
                    )}
                </div>
            </div>
            {<Outlet />}
            {isSocialActive && <SocialItems />}
        </div>
    );
}
